import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8363f096"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "items-in-line" }
const _hoisted_2 = ["disabled", "onClick"]

import { OptionType } from '@/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'OpenSorting',
  props: /*#__PURE__*/_mergeModels({
    sortOptions: {},
    loading: { type: Boolean }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props;
// eslint-disable-next-line no-undef
const modelValue = _useModel<number | string | (number | string)[] | undefined>(__props, "modelValue");

const changeModelValue = (options: OptionType[]) => {
  if (activeValueIndex(options) === 0) {
    modelValue.value = options[1].id;

    return;
  }
  modelValue.value = options[0].id;
};

const activeValueIndex = (options: OptionType[]) => {
  return options.findIndex(el => el.id === modelValue.value);
};

const getCurrentOption = (options: OptionType[]) => {
  return activeValueIndex(options) >= 0 ? options[activeValueIndex(options)] : options[0];
};

return (_ctx: any,_cache: any) => {
  const _component_base_icon = _resolveComponent("base-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortOptions, (options, i) => {
      return (_openBlock(), _createElementBlock("div", { key: i }, [
        _createElementVNode("button", {
          disabled: _ctx.loading,
          class: "items-in-line gap--3",
          onClick: ($event: any) => (changeModelValue(options))
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(activeValueIndex(options) >= 0 ? 'main-color' : 'third-color')
          }, _toDisplayString(getCurrentOption(options).name), 3),
          (getCurrentOption(options).icon)
            ? (_openBlock(), _createBlock(_component_base_icon, {
                key: 0,
                color: activeValueIndex(options) >= 0 ? '#009D3E' : '#94857d',
                name: getCurrentOption(options).icon,
                "font-size": "16"
              }, null, 8, ["color", "name"]))
            : _createCommentVNode("", true)
        ], 8, _hoisted_2)
      ]))
    }), 128))
  ]))
}
}

})